import React, { Component } from 'react';
import { connect } from 'react-redux';
import ExchangeReasonModal from '../../../../views/order/common/modal/ExchangeReasonModal';
import { orderActions } from '../../../../store/modules/order';
import withModal from '../../../../lib/hoc/withModal';

class ExchangeReasonModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'exchangeReasonModal',
    });
  };

  render() {
    const { isOpen, data } = this.props;

    return <ExchangeReasonModal isOpen={isOpen} data={data} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.exchangeReasonModal.isOpen,
    data: state.order.exchangeReasonModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ExchangeReasonModalContainer));
